import { motion } from "framer-motion";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { WHATSAPP_DEFAULT } from "@/lib/site";

export default function WhatsAppFloat() {
    return (
        <motion.a
            href={WHATSAPP_DEFAULT}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label="Agendar pelo WhatsApp"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.8, type: "spring", stiffness: 260, damping: 18 }}
            className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[80] group"
        >
            <span className="absolute inset-0 rounded-full bg-wa opacity-40 animate-ping group-hover:opacity-30" />
            <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-wa hover:bg-[#1EBE5B] text-white shadow-[0_12px_35px_rgba(37,211,102,0.45)] transition-all duration-300 group-hover:scale-105">
                <WhatsAppIcon size={26} />
            </span>
            <span className="hidden sm:block absolute right-full top-1/2 -translate-y-1/2 mr-4 whitespace-nowrap glass border border-white/10 text-xs text-cream px-3.5 py-2 rounded-full opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
                Agendar pelo WhatsApp
            </span>
        </motion.a>
    );
}
